import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import { splitRegistration } from '@cbgms/base/utils/vehicle'

import {
  courtesyVehiclesAddURL,
  courtesyVehiclesBookingsURL,
  courtesyVehiclesDetailsURL,
  courtesyVehiclesURL
} from 'app/replacementVehicles/RouteConstants'

export const CourtesyVehiclesBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()
  const vehicleRegistration = useSelector(state => state.vehicle.detail.Registration)
  const registration = splitRegistration(vehicleRegistration)

  return (
    <Breadcrumbs {...props}>
      <Crumb
        data-testid='crumb-courtesy-vehicles'
        key='crumb-courtesy-vehicles'
        path={courtesyVehiclesURL}
        text={t('ReplacementVehicles.CourtesyVehicles')}
      />
      <Crumb
        data-testid='crumb-courtesy-vehicles-details'
        key='crumb-courtesy-vehicles-details'
        path={courtesyVehiclesDetailsURL}
        exact
        text={registration?.licensePlate ? `${t('vehicle.vehicle')} (${registration.licensePlate})` : t('vehicle.vehicle')}
      />
      <Crumb
        data-testid='crumb-replacement-add-vehicles-fleet'
        key='crumb-replacement-add-vehicles-fleet'
        path={courtesyVehiclesAddURL}
        text={t('global.add')}
      />
      <Crumb
        data-testid='crumb-bookings-per-vehicle-view'
        key='crumb-bookings-per-vehicle-view'
        path='/vehicles/:uuid/bookings'
        text={t('ReplacementVehicles.Bookings')}
      />
      <Crumb
        data-testid='crumb-bookings-view'
        key='crumb-bookings-view'
        path={courtesyVehiclesBookingsURL}
        text={t('ReplacementVehicles.Bookings')}
      />
    </Breadcrumbs>
  )
}

export default CourtesyVehiclesBreadCrumbs
